import React from "react";
import { Button } from "antd";
import style from "./homeworkBlock.module.scss";
import { HomeworkListItem } from "API";
import { sectionDescribe, number2Hanzi } from "Utils/filter";

interface IHomeworkBlockProps {
    courseInfo: HomeworkListItem;
    handleHomework: (
        courseNo: string,
        courseSeq: string,
        weekNo: string,
        dayOfWeek: string,
        section: string,
        continunity: string,
        state: string,
        paperId: string,
        weekTimeId: string
    ) => void;
}

const HomeworkBlock = ({ courseInfo, handleHomework }: IHomeworkBlockProps) => {
    return (
        <div className={style.homework}>
            <h2 className={style.title}>{courseInfo.courseName}</h2>
            <div className={style.desc}>
                <p>授课教师: {courseInfo.teacherName}</p>
                <p>
                    时间：第{number2Hanzi(parseInt(courseInfo.weekTime))}周 周
                    {number2Hanzi(parseInt(courseInfo.week) + 1)}
                </p>
                <p>
                    节次：
                    {sectionDescribe(
                        courseInfo.section,
                        courseInfo.continunity
                    )}
                </p>
                <p>截止日期: {courseInfo.endDate}</p>
            </div>
            <Button
                className={style.btn}
                type="primary"
                size="large"
                onClick={() =>
                    handleHomework(
                        courseInfo.courseNo,
                        courseInfo.courseSeq,
                        courseInfo.weekTime,
                        courseInfo.week,
                        courseInfo.section,
                        courseInfo.continunity,
                        "1",
                        courseInfo.paperId,
                        courseInfo.weekTimeId
                    )
                }>
                做作业
            </Button>
        </div>
    );
};

export default HomeworkBlock;
